import { FC } from "react";
import { IconButton, IconButtonProps, useTheme } from "@mui/material";
import { ShortcutIcon } from "src/theme/overrides/CustomIcons";

const ShortcutLink: FC<IconButtonProps> = ({ ...props }) => {
    const theme = useTheme();

    return (
        <IconButton
            size="small"
            sx={{
                fontSize: 16,
                color: theme.palette.custom.iconButton,
                opacity: 0.3,
                ml: 0.5,
            }}
            {...props}
        >
            <ShortcutIcon fontSize="inherit" color="inherit" />
        </IconButton>
    );
};

export default ShortcutLink;
